export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#E69057',
    light: '#F6F6F6',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#D9EDF7',
    contrastText: '#22211F',
  },
  text: {
    primary: '#22211F',
    secondary: '#49515B',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    hero1: '#2A3D50',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#000000',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#081425',
    tableSubhead: '#F7F8F8',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#081425',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    offer: '#E1F0FF',
    hover1: '#6B5A9A',
    stepperCompleted: '#081425',
  },
  surface: {
    light: '#FCF7F4',
    grey: '#FAFAFA',
    pricing: '#081425',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
